import React, { useEffect, useState } from "react";
import { HiOutlineTicket } from "react-icons/hi";
import useMethodAccount from "./hooks/useMethodAccount";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import SelectPassMobile from "./selectPass/SelectPassMobile";
import SelectPassDesktop from "./selectPass/SelectPassDesktop";
import LimitedOpenPassDesktop from "./limitedOpenPass/LimitedOpenPassesDesktop";
import LimitedOpenPassMobile from "./limitedOpenPass/LimitedOpenPassesMobile";
import { useTranslation } from "react-i18next";
import MobileComponentToShowExercises from "./selectPass/MobileComponentToShowExercises";
import useFacility from "../../../utils/hooks/useFacility";
import ClubCartsDesktop from "./clubCarts/ClubCartsDesktop";
import ClubCartsMobile from "./clubCarts/ClubCartsMobile";
import EAAlert from "../shared/EAAlert";

const AccountPasses: React.FC = () => {
  const { t } = useTranslation();
  const { tickets, passes, getLimited, getSelect } = useMethodAccount();
  const isDesktop = useDesktopSize();
  const [deafult, setDeafult] = useState<boolean>(true);
  const [indexOfTickets, setIndexOfTickets] = useState<number>(999);
  const facilityIds = useFacility();
  useEffect(() => {
    getLimited();
    getSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeDeafultView = (i: number) => {
    setDeafult(false);
    setIndexOfTickets(i);
  };
  const backToDeafultView = () => {
    setDeafult(true);
  };

  return (
    <>
      {deafult ? (
        <div className="account-tickets">









{(facilityIds === "1241" || facilityIds === "1243") && 
        <>
          <h5 className="ticket-title flex-start-center">
            <HiOutlineTicket className="icon" />
            {t("karnet_klubowy")}
          </h5>
          
          <div className="flex-start flex-wrap">
            {passes.length > 0 ? (
              <>
                {passes.map((ticket, index) => (
                  <div key={index} className="select-pass-container">
                    {isDesktop ? (
                      <ClubCartsDesktop ticket={ticket} getSelect={getLimited} />
                    ) : (
                      <ClubCartsMobile ticket={ticket} getSelect={getLimited} />
                    )}
                  </div>
                ))}
              </>
            ) : (
              <>
              <EAAlert
                  message={t("brak_karnetow")}
                  type="warning"
          
                />
          
              </>
            )}
          </div>
          </>
        }



          <h5 className="ticket-title flex-start-center">
            <HiOutlineTicket className="icon" />
            {t("karnety_zajeciowe")}
          </h5>

          <div className="flex-start flex-wrap">
            {passes.length > 0 ? (
              <>
                {passes.map((passes, index) => (
                  <>
                    {isDesktop ? (
                      <div key={index} className="select-pass-container">
                        <SelectPassDesktop ticket={passes} getSelect={getSelect} />
                      </div>
                    ) : (
                      <div key={index} className="select-pass-container">
                        <SelectPassMobile
                          ticket={passes}
                          getSelect={getSelect}
                          changeDeafultView={changeDeafultView}
                          index={index}
                        />
                      </div>
                    )}
                  </>
                ))}
              </>
            ) : (
              <>
               <>
              <EAAlert
                  message={t("brak_karnetow")}
                  type="warning"
          
                />
          
              </>
              </>
            )}
          </div>

          <h5 className="ticket-title flex-start-center">
            <HiOutlineTicket className="icon" />
            {t("karnety_open_i_ilosciowe")}
          </h5>

          <div className="flex-start flex-wrap">
            {passes.length > 0 ? (
              <>
                {passes.map((passes, index) => (
                  <div key={index} className="select-pass-container">
                    {isDesktop ? (
                      <LimitedOpenPassDesktop ticket={passes} getSelect={getLimited} />
                    ) : (
                      <LimitedOpenPassMobile ticket={passes} getSelect={getLimited} />
                    )}
                  </div>
                ))}
              </>
            ) : (
              <>
              <>
              <EAAlert
                  message={t("brak_karnetow")}
                  type="warning"
          
                />
          
              </>
              </>
            )}
          </div>
        </div>
      ) : (
        <MobileComponentToShowExercises
          ticket={tickets[indexOfTickets]}
          getSelect={getSelect}
          backToDeafultView={backToDeafultView}
        />
      )}
    </>
  );
};

export default AccountPasses;
